import script from "./DisclaimerPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisclaimerPop.vue?vue&type=script&lang=ts&setup=true"

import "./DisclaimerPop.vue?vue&type=style&index=0&id=503758a6&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13+webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503758a6"]])

export default __exports__